
export const FETCH_DOC_PROFILE_SUCCESS = "FETCH_DOC_PROFILE_SUCCESS";
export const UPDATE_DOC_PROFILE_SUCCESS = "UPDATE_DOC_PROFILE_SUCCESS";

export const SHOW_MODAL = "SHOW_MODAL";
export const MODAL_CONFIG = "MODAL_CONFIG";
export const UPDATE_MODAL_UI_CONFIG = "UPDATE_MODAL_UI_CONFIG";
export const UPDATE_FORMATTED_CONFIG_AVAILABLE = "UPDATE_FORMATTED_CONFIG_AVAILABLE";
export const MODAL_TYPE = "MODAL_TYPE";
export const ADD_SYMPTOM_FOR_REVIEW = "ADD_SYMPTOM_FOR_REVIEW";
export const ADD_NEW_SYMPTOM = "ADD_NEW_SYMPTOM";
export const ADD_BUTTON_CLICKED = "ADD_BUTTON_CLICKED";

export const GET_IS_ACTIVE_COVID_PACK = "GET_IS_ACTIVE_COVID_PACK";

export const SAVE_PATIENT_LAB_TESTS_SUCCESS = "SAVE_PATIENT_LAB_TESTS_SUCCESS";
export const SAVE_PATIENT_LAB_TESTS = "SAVE_PATIENT_LAB_TESTS";
export const UPDATE_USER_ID = "UPDATE_USER_ID";
export const RESET_STORE = "RESET_STORE";

export const FETCH_ACCOUNT_DATA_SUCCESS = "FETCH_ACCOUNT_DATA_SUCCESS";
export const FETCH_PATIENT_PROFILE_SUCCESS = "FETCH_PATIENT_PROFILE_SUCCESS";
export const FETCH_ALL_STATIC_DATA_SUCCESS = "FETCH_ALL_STATIC_DATA_SUCCESS";
export const FETCH_ALL_STATIC_DATA_SUCCESS_NEW = "FETCH_ALL_STATIC_DATA_NEW_SUCCESS";
export const FETCH_PLAN_STATIC_DATA_SUCCESS = "FETCH_PLAN_STATIC_DATA_SUCCESS";

export const FETCH_LAB_TESTS_SUCCESS = "FETCH_LAB_TESTS_SUCCESS";

export const FETCH_ROUTINE_ATTRIBUTE_DATA_SUCCESS = "FETCH_ROUTINE_ATTRIBUTE_DATA_SUCCESS";
export const FETCH_FOOD_GROUPS_DATA_SUCCESS = "FETCH_FOOD_GROUPS_DATA_SUCCESS";

export const FETCH_DOCTOR_APPOINTMENTS_SUCCESS = "FETCH_DOCTOR_APPOINTMENTS_SUCCESS";
export const FETCH_APPOINTMENTS_FOR_PATIENT_SUCCESS = "FETCH_UPCOMING_DOCTOR_APPOINTMENTS_FOR_PATIENT_SUCCESS";
export const FETCH_CENTER_APPOINTMENTS_SUCCESS = "FETCH_CENTER_APPOINTMENTS_SUCCESS";

export const FETCH_ALL_DOCTOR_APPOINTMENTS_SUCCESS = "FETCH_ALL_DOCTOR_APPOINTMENTS_SUCCESS";

export const FETCH_PATIENT_COMPLETE_DETAILS_SUCCESS = "FETCH_PATIENT_COMPLETE_DETAILS_SUCCESS";
export const CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS = "CLEAR_PATIENT_COMPLETE_DETAILS_SUCCESS";
export const FETCH_PATIENT_VITALS_SUCCESS = "FETCH_PATIENT_VITALS_SUCCESS";
export const SAVE_PATIENT_VITALS_SUCCESS = "SAVE_PATIENT_VITALS_SUCCESS";
export const FETCH_PATIENT_SURGERY_SUCCESS = "FETCH_PATIENT_SURGERY_SUCCESS";
export const SAVE_PATIENT_SURGERY_SUCCESS = "SAVE_PATIENT_SURGERY_SUCCESS";
export const FETCH_PATIENT_ALLERGY_SUCCESS = "FETCH_PATIENT_ALLERGY_SUCCESS";
export const SAVE_PATIENT_ALLERGY_SUCCESS = "SAVE_PATIENT_ALLERGY_SUCCESS";
export const FETCH_PATIENT_HABIT_SUCCESS = "FETCH_PATIENT_HABIT_SUCCESS";
export const SAVE_PATIENT_HABIT_SUCCESS = "SAVE_PATIENT_HABIT_SUCCESS";
export const FETCH_PATIENT_CURRENT_MEDICATION_SUCCESS = "FETCH_PATIENT_CURRENT_MEDICATION_SUCCESS";
export const SAVE_PATIENT_CURRENT_MEDICATION_SUCCESS = "SAVE_PATIENT_CURRENT_MEDICATION_SUCCESS";
export const FETCH_PATIENT_COMORBID_CONDITIONS_SUCCESS = "FETCH_PATIENT_COMORBID_CONDITIONS_SUCCESS";
export const SAVE_PATIENT_COMORBID_CONDITIONS_SUCCESS = "SAVE_PATIENT_COMORBID_CONDITIONS_SUCCESS";
export const FETCH_PATIENT_LAB_TESTS_SUCCESS = "FETCH_PATIENT_LAB_TESTS_SUCCESS";
export const FETCH_PATIENT_PERSONAL_INFORMATION_SUCCESS = "FETCH_PATIENT_PERSONAL_INFORMATION_SUCCESS";
export const FETCH_PATIENT_CONCERNS_SUCCESS = "FETCH_PATIENT_CONCERNS_SUCCESS";
export const FETCH_RED_FLAGS_SUCCESS = "FETCH_RED_FLAGS_SUCCESS";
export const FETCH_PATIENT_MEDICAL_PROFILE_SUCCESS = "FETCH_PATIENT_MEDICAL_PROFILE_SUCCESS";
export const FETCH_PATIENT_PAST_SESSIONS_SUCCESS = "FETCH_PATIENT_PAST_SESSIONS_SUCCESS";
export const SAVE_PATIENT_MEDICAL_PROFILE_SUCCESS = "SAVE_PATIENT_MEDICAL_PROFILE_SUCCESS";
export const FETCH_PATIENT_TYPE_FORM_DATA_SUCCESS = "FETCH_PATIENT_TYPE_FORM_DATA_SUCCESS";
export const FETCH_ONGOING_CONSULTATION_DETAILS_SUCCESS = "FETCH_ONGOING_CONSULTATION_DETAILS_SUCCESS";
export const UPDATE_DIAGNOSTIC_LABTESTS_DETAILS = "UPDATE_DIAGNOSTIC_LABTESTS_DETAILS";
export const UPDATE_MANUAL_LABTESTS_DETAILS = "UPDATE_MANUAL_LABTESTS_DETAILS";
export const CLEAR_ONGOING_CONSULTATION_DETAILS = "CLEAR_ONGOING_CONSULTATION_DETAILS";
export const UPDATE_CURRENT_PRESCRIPTION = "UPDATE_CURRENT_PRESCRIPTION";
export const UPDATE_CURRENT_PATIENT_GOALS = "UPDATE_CURRENT_PATIENT_GOALS";
export const UPDATE_CURRENT_PATIENT_SECONDARY_GOALS = "UPDATE_CURRENT_PATIENT_SECONDARY_GOALS";
export const UPDATE_CURRENT_PATIENT_INTERVENTIONS = "UPDATE_CURRENT_PATIENT_INTERVENTIONS";
export const UPDATE_CURRENT_ALLERGIES = "UPDATE_CURRENT_ALLERGIES";
export const UPDATE_CHIEF_COMPLAINTS = "UPDATE_CHIEF_COMPLAINTS";
export const UPDATE_ILLNESSES = "UPDATE_ILLNESSES";
export const UPDATE_PAST_CONDITIONS = "UPDATE_PAST_CONDITIONS";
export const UPDATE_EXAMINATIONS = "UPDATE_EXAMINATIONS";
export const UPDATE_SYSTEMIC_EXAMINATIONS = "UPDATE_SYSTEMIC_EXAMINATIONS";
export const UPDATE_MENTAL_STATUS_EXAMINATIONS = "UPDATE_MENTAL_STATUS_EXAMINATIONS";
export const UPDATE_MEDICAL_PROFILE = "UPDATE_MEDICAL_PROFILE";
export const UPDATE_PATIENT_PERSONAL_INFO = "UPDATE_PATIENT_PERSONAL_INFO";
export const UPDATE_APPOINTMENT_SUCCESS = "UPDATE_APPOINTMENT_SUCCESS";
export const SAVE_REVIEW_OF_SYSTEMS_DATA = "SAVE_REVIEW_OF_SYSTEMS_DATA"
export const UPDATE_PATIENT_PLAN = "UPDATE_PATIENT_PLAN";


export const FETCH_CENTER_INFO_SUCCESS = "FETCH_CENTER_INFO_SUCCESS";
export const FETCH_CENTER_ROOMS_SUCCESS = "FETCH_CENTER_ROOMS_SUCCESS";
export const FETCH_CENTER_DOCTORS_SUCCESS = "FETCH_CENTER_DOCTORS_SUCCESS";

export const FETCH_CHAT_ACCESS_TOKEN_SUCCESS = "FETCH_CHAT_ACCESS_TOKEN_SUCCESS";
export const FETCH_VIDEO_ACCESS_TOKEN_SUCCESS = "FETCH_VIDEO_ACCESS_TOKEN_SUCCESS";
export const LOAD_GENERAL_EXAMINATION_SUCCESS = "LOAD_GENERAL_EXAMINATION_SUCCESS";

export const LOAD_VITAL_DATA_SUCCESS = "LOAD_VITAL_DATA_SUCCESS";
export const LOAD_PATIENT_VITAL_DATA_SUCCESS = "LOAD_PATIENT_VITAL_DATA_SUCCESS";

export const UPDATE_TWILIO_ACCESS_TOKEN = "UPDATE_TWILIO_ACCESS_TOKEN";
export const SET_TWILIO_CLIENTS = "SET_TWILIO_CLIENTS";
export const UPDATE_TWILIO_TOTAL_UNREAD_COUNT = "UPDATE_TWILIO_TOTAL_UNREAD_COUNT";
export const UPDATE_TWILIO_LAST_X_CONVERSATIONS = "UPDATE_TWILIO_LAST_X_CONVERSATIONS";
export const UPDATE_TWILIO_USER_IDENTITY = "UPDATE_TWILIO_USER_IDENTITY";
export const UPDATE_TWILIO_CHANNEL_INFO = "UPDATE_TWILIO_USER_CHANNEL_INFO";
export const UPDATE_TWILIO_CURRENT_CHANNEL = "UPDATE_TWILIO_CURRENT_CHANNEL";
export const UPDATE_TWILIO_CURRENT_CHANNEL_WITH_PATIENT = "UPDATE_TWILIO_CURRENT_CHANNEL_WITH_PATIENT";
export const SET_TWILIO_CURRENT_CHANNEL = "SET_TWILIO_CURRENT_CHANNEL";
export const CHANNEL_SYNCHRONIZATION_COMPLETE = "CHANNEL_SYNCHRONIZATION_COMPLETE";
export const FETCH_UNREAD_MESSAGE_INFO = "FETCH_UNREAD_MESSAGE_INFO";
export const CLEAR_CURRENT_CHANNEL = "CLEAR_CURRENT_CHANNEL";
export const UPDATE_CONNECTION_STRENGTH = "UPDATE_CONNECTION_STRENGTH";
export const UPDATE_CURRENT_PATIENT_TRACKABLE_SYMPTOMS = "UPDATE_CURRENT_PATIENT_TRACKABLE_SYMPTOMS";
export const SAVE_FETCHED_USER_METRICS = "SAVE_FETCHED_USER_METRICS";
export const SAVE_ONGOING_CONSULTATION_PRODUCT = "SAVE_ONGOING_CONSULTATION_PRODUCT";
export const SAVE_PATIENT_ADHERENCE_DATA = "SAVE_PATIENT_ADHERENCE_DATA";
export const GET_ALL_PATIENTS_FOR_SEGMENT_MP = "GET_ALL_PATIENTS_FOR_SEGMENT_MP";
export const SAVE_ADHERENCE_ACTIVITY_DATA = "SAVE_ADHERENCE_ACTIVITY_DATA";
export const SAVE_PATIENT_PLAN_VIEW = "SAVE_PATIENT_PLAN_VIEW";
export const SAVE_PATIENT_GOALS_VIEW = "SAVE_PATIENT_GOALS_VIEW";
export const SAVE_PATIENT_METRICS_DATA = "SAVE_PATIENT_METRICS_DATA";
export const FETCH_STATIC_DIET_RECALL_DATA = "FETCH_STATIC_DIET_RECALL_DATA";
export const SAVE_PATIENTS_OVERALL_ADHERENCE_SCORES = "SAVE_PATIENTS_OVERALL_ADHERENCE_SCORES";
export const GET_UI_CONFIGURATION = "GET_UI_CONFIGURATION";

export const UPDATE_PATIENT_WHATSAPP_INFO = "UPDATE_PATIENT_WHATSAPP_INFO"
export const TOGGLE_WHATSAPP_CHAT = "TOGGLE_WHATSAPP_CHAT"
export const CLOSE_WHATSAPP_CHAT = "CLOSE_WHATSAPP_CHAT"

export const FETCH_PATIENT_PLAN_ELIGIBILITY_INFO_SUCCESS = "FETCH_PATIENT_PLAN_ELIGIBILITY_INFO_SUCCESS";
export const SAVE_EDITED_LAB_TESTS = "SAVE_EDITED_LAB_TESTS";
export const SAVE_PATIENT_DIAGNOSTIC_LAB_TESTS = "SAVE_PATIENT_DIAGNOSTIC_LAB_TESTS";
export const SAVE_CONSULTATION_TEMPLATES_RESPONSE = "SAVE_CONSULTATION_TEMPLATES_RESPONSE";
export const UPDATE_NO_PRESENTING_ILLNESS = "UPDATE_NO_PRESENTING_ILLNESS";
export const UPDATE_CURRENT_CONSULTATION_DATA = "UPDATE_CURRENT_CONSULTATION_DATA";
export const UPDATE_CURRENT_CONFIG_MEDICAL_PROFILE = "UPDATE_CURRENT_CONFIG_MEDICAL_PROFILE";
export const UPDATE_EDIT_CURRENT_CONSULTATION_DATA = "UPDATE_EDIT_CURRENT_CONSULTATION_DATA";
export const SAVE_SUB_SECTIONS_RECOMMENDATIONS = "SAVE_SUB_SECTIONS_RECOMMENDATIONS";
export const UPDATE_NEW_CONFIG_DATA = "UPDATE_NEW_CONFIG_DATA";
export const UPDATE_EDIT_SUGGESTIONS_CONSULTATION_DATA = "UPDATE_EDIT_SUGGESTIONS_CONSULTATION_DATA";
export const UPDATE_SUGGESTIONS_CONSULTATION_DATA = "UPDATE_SUGGESTIONS_CONSULTATION_DATA";

export const SAVE_PAST_CONSULTATION_DATA = "SAVE_PAST_CONSULTATION_DATA";

export const UPDATE_EDIT_CONSULTATION_DETAILS = "UPDATE_EDIT_CONSULTATION_DETAILS";
export const SAVE_EDIT_PRESCRIPTION_TEMPLATES_RESPONSE = "SAVE_EDIT_PRESCRIPTION_TEMPLATES_RESPONSE";
export const CLEAR_EDIT_PRESCRIPTION_DETAILS = "CLEAR_EDIT_PRESCRIPTION_DETAILS";
export const FETCH_EDIT_PRESCRIPTION_DETAILS_SUCCESS = "FETCH_EDIT_PRESCRIPTION_DETAILS_SUCCESS";
export const SAVE_EDIT_SUB_SECTIONS_RECOMMENDATIONS = "SAVE_EDIT_SUB_SECTIONS_RECOMMENDATIONS";
export const UPDATE_PATIENT_NUMBER_FOR_AUDIO_CALL = "UPDATE_PATIENT_NUMBER_FOR_AUDIO_CALL";

export const SAVE_FEATURE_CONFIG_INFO = "SAVE_FEATURE_CONFIG_INFO";
export const CLEAR_FEATURE_CONFIG_INFO = "CLEAR_FEATURE_CONFIG_INFO";
export const GET_USERFORM_DATA = "GET_USERFORM_DATA";
export const SEND_USERFORM_DATA = "SEND_USERFORM_DATA";

export const SUBMIT_CONSULTATION_FEEDBACK_FORM = "SUBMIT_CONSULTATION_FEEDBACK_FORM";
export const STORE_APPLIED_TEMPLATES_ONGOING = "STORE_APPLIED_TEMPLATES_ONGOING";
export const STORE_APPLIED_TEMPLATES_EDIT = "STORE_APPLIED_TEMPLATES_EDIT";
export const STORE_TEMPLATES_IDS_NAMES_MAP = "STORE_TEMPLATES_IDS_NAMES_MAP";
export const REMOVE_APPLIED_TEMPLATES_ONGOING = "REMOVE_APPLIED_TEMPLATES_ONGOING";
export const REMOVE_APPLIED_TEMPLATES_EDIT = "REMOVE_APPLIED_TEMPLATES_EDIT"

export const ADD_USED_SUGGESTION_FOR_EDITOR = "ADD_USED_SUGGESTION_FOR_EDITOR";

export const SAVE_EXERCISES = "SAVE_EXERCISES";
export const SET_USER_FITNESS_PLAN_DETAILS = "SET_USER_FITNESS_PLAN_DETAILS";

export const SET_ONGOING_CONSULTATION_FITNESS_PLAN = "SET_ONGOING_CONSULTATION_FITNESS_PLAN";
export const SAVE_EXERCISES_FOR_ONGOING_FITNESS_PLAN = "SAVE_EXERCISES_FOR_ONGOING_FITNESS_PLAN";
export const SET_ONGOING_CONSULTATION_USER_FITNESS_PLAN = "SET_ONGOING_CONSULTATION_USER_FITNESS_PLAN";
